module.exports = __webpack_public_path__ + "img/tree-green.465c0a13.svg";